import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { constants as extrasConstants } from 'utils/extras';

import { selectors as settingsSelectors } from 'state/settings';
import {
  actions as orderActions,
  selectors as orderSelectors,
} from 'state/order';
import VehicleExtras from 'components/form/VehicleExtras/component';

const enhance = compose(
  withTranslation('VehicleExtras'),
  connect(
    (state) => ({
      extras: settingsSelectors.getCountrySettings(state).extras,
      extrasInOrder: orderSelectors.getExtras(state),
    }),
    {
      setExtra: orderActions.setExtra,
    }
  ),
  withHandlers({
    handleExtra:
      ({ setExtra }) =>
      (e) => {
        setExtra(e.target.name);
      },
  }),
  withProps(({ t, extras }) => ({
    title: t('title'),
    extrasKeys: (extras || []).filter(
      (extra) => !extrasConstants.HANDLING_EXTRAS.includes(extra)
    ),
  }))
);

export default enhance(VehicleExtras);
